export default "__VITE_ASSET__7f9e0ad6__"